import { render, staticRenderFns } from "./addBankList.vue?vue&type=template&id=eb297c3e&scoped=true"
import script from "./addBankList.vue?vue&type=script&lang=js"
export * from "./addBankList.vue?vue&type=script&lang=js"
import style0 from "./addBankList.vue?vue&type=style&index=0&id=eb297c3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb297c3e",
  null
  
)

export default component.exports